<template>
  <div class="ba-button-select" :class="{ vertical, disabled, all }">
    <ba-button v-for="(item, index) in items"
               :key="`buttonSelect${item.name}`"
               :icon="item.icon"
               :iconHover="item.iconHover"
               :iconActive="item.iconActive"
               :color="item.color"
               :colorHover="item.colorHover"
               :colorActive="all ? null : item.colorActive"
               :disabled="item.disabled === true || disabled === true"
               :hideLabel="item.hideLabel === true"
               :active="on === item.name || all"
               @click="onChange(item.value, index)">
      <span v-html="item.label"></span>
    </ba-button>
    <slot/>
  </div>
</template>

<script>
import BaButton from '@/components/ui/ba/Button'

export default {
  name: 'BaButtonSelect',
  components: {
    BaButton
  },
  props: {
    items: {},
    vertical: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    on: {
      type: String,
      required: false
    },
    all: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange (value, index) {
      this.$emit('change', value)
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-button-select {
  border-radius: 5px;
  background-color: #ffffff;
  transition: opacity 0.2s ease;

  &.all {
    background-color: #EC0047;
    box-shadow: 0px 2px 4px 0px #00000059 inset;

    :not(:last-child) {
      & /deep/ button {
        border-right: 1px solid #FFFFFF47;
      }
    }
    & /deep/ .ba-button {
      button {
        min-width: 85px;

        &.active {
          box-shadow: none !important;
          background: none;
        }
      }
    }
  }

  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;

    & /deep/ .ba-button {
      button {
        &:disabled {
          opacity: 1;
        }
      }
    }
  }

  & /deep/ .ba-button {
    button {
      border-radius: 0;
      box-shadow: inset 0 0 0 1px #e0e0e0;
      -webkit-box-shadow: inset 0 0 0 1px #e0e0e0;
    }
  }

  &.vertical {
    & /deep/ .ba-button {
      button {
        border-right: none;
        border-bottom: 1px solid #e7e7e7;

        &:active,
        &.active {
          border-bottom-color: transparent;
        }
      }

      &:first-child {
        button {
          border-top-right-radius: 5px;
          border-bottom-left-radius: 0;
        }
      }

      &:last-child {
        button {
          border-bottom: none;
          border-top-right-radius: 0;
          border-bottom-right-radius: 5px;
          border-bottom-left-radius: 5px;
        }
      }
    }
  }
}
</style>
